import axiosInstance from '../api';
import { notification } from 'antd';

// Get all users
export const getAllUsers = async ({
  skip = 0,
  limit = 10,
  name = "",
  city_ids = [],
  state_ids = [],
  country_ids = [],
  active = [],
  recommendation_ids = [],
  order = "desc",
  start_date = null,
  end_date = null,
  tag_ids = null,
} = {}) => {
  try {
    const params = new URLSearchParams();
    params.append("skip", skip);
    params.append("limit", limit);
    if (name) params.append("name", name);
    if (city_ids.length) params.append("city_ids", city_ids.join(","));
    if (state_ids.length) params.append("state_ids", state_ids.join(","));
    if (country_ids.length) params.append("country_ids", country_ids.join(","));
    if (recommendation_ids.length) params.append("recommendation_ids", recommendation_ids.join(","));
    if (active.length) params.append("active", active.join(","));
    if (order) params.append("order", order);
    if (tag_ids) params.append("tag_ids", tag_ids)

    if(start_date && end_date){
      params.append("start_date", start_date);
      params.append("end_date", end_date);
    }

    const response = await axiosInstance.get(`/users/?${params.toString()}`);
    if(response?.data?.status_code === 200){
      return response?.data?.data;
    }
    notification.error({
      message: "Error Fetching Users",
      description: response?.data?.message || "Failed to fetch user list.",
      duration: 3,
    });
    
  } catch (error) {
    console.log("error -->", error)
    notification.error({
      message: "Error Fetching Users",
      description: error.response?.data?.message || "Failed to fetch user list.",
      duration: 3,
    });
    throw new Error("Error fetching user list");
  }
};

// Get cities
export const fetchCities = async (page, name, state_id) => {
  try {
    const params = {
      skip: page * 10,
      limit: 10,
      name: name || "",
    };

    if (state_id) {
      params.state_id = state_id; // Only add if present
    }

    const response = await axiosInstance.get("/list/cities", { params });

    if (response?.data?.status_code === 200) {
      return response?.data?.data?.cities.map((item) => ({
        label: item.name,
        value: item.id,
      }));
    }

    notification.error({
      message: "Error Fetching Cities",
      description: response?.data?.message || "Failed to fetch Cities list.",
      duration: 3,
    });

    return [];
  } catch (error) {
    console.error("Error fetching cities", error);
    throw new Error("Error fetching cities");
  }
};


// Get states
export const fetchStates = async (page, name, country_id) => {
  try {
    const params = {
      skip: page * 10,
      limit: 10,
      name: name || "",
    };

    if (country_id) {
      params.country_id = country_id; // Only add if present
    }

    const response = await axiosInstance.get("/list/states", { params });

    if (response?.data?.status_code === 200) {
      return response?.data?.data?.states.map((item) => ({
        label: item.name,
        value: item.id,
      }));
    }

    notification.error({
      message: "Error Fetching States",
      description: response?.data?.message || "Failed to fetch States list.",
      duration: 3,
    });

    return [];
  } catch (error) {
    console.error("Error fetching states", error);
    throw new Error("Error fetching states");
  }
};


// Get countries
export const fetchCountries = async (page, name) => {
  try {
    const response = await axiosInstance.get(`/list/countries?skip=${page * 10}&limit=10&name=${name}`);
    if(response?.data?.status_code === 200){
      return response?.data?.data?.countries.map((item) => ({ label: item.name, value: item.id }));
    }
    notification.error({
      message: "Error Fetching Countries",
      description: response?.data?.message || "Failed to fetch Countries list.",
      duration: 3,
    });
    return []
  } catch (error) {
    console.error("Error fetching countries", error);
    throw new Error("Error fetching countries");
  }
};

// update user
export const updateUser = async (updateId, updatedValues) => {
  try {

    const payload = { user_id : updateId, ...updatedValues}
    const response = await axiosInstance.put(`/users/user_update_admin`, payload);

    if (response.data.status_code === 200) {
      notification.success({
        message: "Success",
        description: response.data.message,
        duration: 3,
      });
      return response.data.data;
    } else {
      notification.error({
        message: "Update Error",
        description: response.data.message || "An error occurred during update.",
        duration: 3,
      });
      return false
    }
  } catch (error) {
    notification.error({
      message: "Update Failed",
      description: error.response?.data?.message || "An unexpected error occurred.",
      duration: 3,
    });
    throw new Error(error.response?.data?.message || "Error updating user");
  }
};

// update user
export const changePassword = async (data) => {
  try {

    const payload = {...data}
    const response = await axiosInstance.post(`/users/change_password`, payload);

    if (response.data.status_code === 200) {
      notification.success({
        message: "Success",
        description: response.data.message,
        duration: 3,
      });
      return response.data.data;
    } else {
      notification.error({
        message: "Update Error",
        description: response.data.message || "An error occurred during update.",
        duration: 3,
      });
    }
  } catch (error) {
    notification.error({
      message: "Update Failed",
      description: error.response?.data?.message || "An unexpected error occurred.",
      duration: 3,
    });
    throw new Error(error.response?.data?.message || "Error updating password");
  }
};

export const activateDeactivateUser = async (updateId, updatedValues) => {
  try {
    const payload = { user_id : updateId, ...updatedValues}
    const response = await axiosInstance.put(`/users/activate_deactivate`, payload);

    if (response.data.status_code === 200) {
      notification.success({
        message: "Success",
        description: response.data.message,
        duration: 3,
      });
      return response.data.data;
    } else {
      notification.error({
        message: "Update Error",
        description: response.data.message || "An error occurred during update.",
        duration: 3,
      });
    }
  } catch (error) {
    notification.error({
      message: "Update Failed",
      description: error.response?.data?.message || "An unexpected error occurred.",
      duration: 3,
    });
    throw new Error(error.response?.data?.message || "Error updating user");
  }
};

export const fetchRecommendations = async (page, name) => {
  try {
    const params = {
      skip: page * 10,
      limit: 10,
      name: name || "",
    };

    const response = await axiosInstance.get(
      `/recommendation/all`, { params }
    );
    console.log("response -->", response)
    if (response?.data?.status_code === 200) {
      return response?.data?.data?.recommendations.map((item) => ({
        label: item.name,
        value: item.id,
      }));
    }
    notification.error({
      message: "Error Fetching Recommendations",
      description:
        response?.data?.message || "Failed to fetch Recommendations list.",
      duration: 3,
    });
    return []
  } catch (error) {
    notification.error({
      message: "Error Fetching recommendation",
      description:
        error.response?.data?.message || "Failed to fetch recommendation list.",
      duration: 3,
    });
    throw new Error("Error fetching recommendation list");
  }
};

export const downloadUsers = async ({
  name = "",
  city_ids = [],
  state_ids = [],
  country_ids = [],
  active = [],
  recommendation_ids = [],
  order = "desc",
  start_date=null, 
  end_date=null,
  tag_ids = []
} = {}) => {
  try {
    const params = new URLSearchParams();
    if (name) params.append("name", name);
    if (city_ids.length) params.append("city_ids", city_ids.join(","));
    if (state_ids.length) params.append("state_ids", state_ids.join(","));
    if (country_ids.length) params.append("country_ids", country_ids.join(","));
    if (recommendation_ids.length) params.append("recommendation_ids", recommendation_ids.join(","));
    if (active.length) params.append("active", active.join(","));
    if (order) params.append("order", order);
    if (start_date) params.append("start_date", start_date);
    if (end_date) params.append("end_date", end_date);
    if (tag_ids.length) params.append("tag_ids", tag_ids.join(","));

    const response = await axiosInstance.get(`/users/download?${params.toString()}`, {
      responseType: "blob", // Ensures the response is treated as a file
    });

    if (response.status === 200) {
      const blob = new Blob([response.data], { type: "text/csv" });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "users.csv"; // Set the filename
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
      
      return response; 
    } else {
      throw new Error("Download failed"); 
    }
  } catch (error) {
    console.error("Error downloading users:", error);
    notification.error({
      message: "Error Downloading Users",
      description: error.response?.data?.message || "Failed to download user list.",
      duration: 3,
    });
    throw error; 
  }
};

export const getDashboardDetails = async () => {
  const response = await axiosInstance.get(`/users/dashboard`, {});

  if (response.data.status_code === 200) {
    return response.data.data;
  } else {
    throw new Error(response.data.message || "Failed to get dashboard");
  }
};